import Navbar from '../../pages/private/common/Navigation/Navbar';
import AnalyticsPage from '../../pages/private/analytics/AnalyticsPage';
import { CONSTANT } from '../../utils/constants';
import { useNavigationContext } from '../../contexts/NavigationContext';
import Welcome from "../../pages/private/common/Welcome"
function MainLayout({ children, scope = null, enableAnalytics = false, websiteLabel }) {
  const { navigationContext } = useNavigationContext();
  return (
    <div className="flex flex-row h-screen w-screen">
      <Navbar />
      <div className="w-full h-auto overflow-scroll">
        {children}
        {enableAnalytics &&
          <AnalyticsPage
            isActive={navigationContext.activeAppKey === 'analytics'}
            scope={scope}
            wip={true}
            config={CONSTANT[scope]?.analytics ? CONSTANT[scope].analytics : undefined}
          />}
        <Welcome isActive={!navigationContext.activeAppKey} websiteLabel={websiteLabel} />
      </div>

    </div>
  );
}

export default MainLayout;
